import { useMutation, useQuery } from '@tanstack/react-query'
import useRequest from '../useRequest'
import { FIND_INVOICE, GET_INVOICE_AUTOCOMPLETE } from '../../services/URLs'

const MUTATIONS = {
  FIND_INVOICE: 'FIND_INVOICE',
}

const QUERIES = {
  GET_INVOICE_AUTOCOMPLETE: 'GET_INVOICE_AUTOCOMPLETE',
}

export const useFindInvoice = () => {
  const request = useRequest();
  
  return useMutation({
    mutationKey: [MUTATIONS.FIND_INVOICE],
    mutationFn: async (payload: { partNo: string }) => {
      return await request({
        method: 'get',
        url: FIND_INVOICE + `?invoiceNum=${payload.partNo}`,
        payload,
        config: { responseType: 'blob', headers: {} },
        completeResponse: true,
      });
    },
  });
}

export const useGetInvoiceAutocomplete = (prefix: string) => {
  const request = useRequest();

  return useQuery({
    queryKey: [QUERIES.GET_INVOICE_AUTOCOMPLETE, prefix],
    queryFn: async () => {
      if (!prefix || prefix.trim().length < 2) {
        return { invoiceNumbers: [] };
      }
      
      return await request({
        method: 'get',
        url: GET_INVOICE_AUTOCOMPLETE,
        config: {
          params: { prefix: prefix.trim() },
        },
        completeResponse: false,
      });
    },
    enabled: !!prefix && prefix.trim().length >= 2,
    staleTime: 5 * 60 * 1000, // 5 minutes cache
    gcTime: 10 * 60 * 1000, // 10 minutes garbage collection
  });
}